import React from 'react';

const Wallets = () => {
  return <h2>Wallets Management Page</h2>;
};

export default Wallets;
